import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "billetage-form container p-15 p-md-40" }
const _hoisted_3 = { class: "fw-bold text-black mb-15 mb-md-25" }
const _hoisted_4 = { class: "div row" }
const _hoisted_5 = { class: "div col-md-12" }
const _hoisted_6 = { class: "div row" }
const _hoisted_7 = { class: "div col-md-6" }
const _hoisted_8 = { class: "div form-group mb-12" }
const _hoisted_9 = { class: "div col-md-6" }
const _hoisted_10 = { class: "div form-group mb-12" }
const _hoisted_11 = { class: "div row gx-4" }
const _hoisted_12 = { class: "div col-md-6 mb-md-12" }
const _hoisted_13 = {
  class: "div border mb-5",
  style: {"border-color":"#a40a0a !important"}
}
const _hoisted_14 = {
  class: "div row fw-bold py-2",
  style: {"background-color":"#a40a0a"}
}
const _hoisted_15 = { class: "div col-md-5" }
const _hoisted_16 = {
  key: 0,
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_17 = { class: "div px-3" }
const _hoisted_18 = { class: "div row align-items-center" }
const _hoisted_19 = { class: "div col-md-4 px-1" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "div col-md-4 px-1" }
const _hoisted_22 = { class: "div col-md-4 px-1" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "div col-md-6 mb-md-12" }
const _hoisted_25 = {
  class: "div border mb-5",
  style: {"border-color":"#0a59a4 !important"}
}
const _hoisted_26 = {
  class: "div row fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_27 = { class: "col-md-5" }
const _hoisted_28 = {
  key: 0,
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_29 = { class: "div px-3" }
const _hoisted_30 = { class: "div row align-items-center" }
const _hoisted_31 = { class: "div col-md-4 px-1" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "div col-md-4 px-1" }
const _hoisted_34 = { class: "div col-md-4 px-1" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_37 = { class: "div mb-3 mt-1" }
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_Form, {
        ref: "billetageForm",
        onSubmit: _ctx.addOperation,
        "validation-schema": _ctx.operationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "div d-flex align-items-center justify-content-between" }, [
                      _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, [
                        _createTextVNode(" Bénéficiaire"),
                        _createElementVNode("span", { class: "span text-danger" }, "*")
                      ])
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "beneficiaire",
                      class: "form-control compact-input"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "beneficiaire",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, " Autre Informations ", -1)),
                    _createVNode(_component_Field, {
                      name: " autreInformation",
                      class: "form-control compact-input"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: " autreInformation",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-center mb-4 mt-3" }, [
                _createElementVNode("h4", { class: "fw-bold text-primary" }, "Conversion de Billets")
              ], -1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "div col-md-7" }, [
                        _createElementVNode("h3", { class: "h3 fs-4 text-white" }, "SORTIES")
                      ], -1)),
                      _createElementVNode("div", _hoisted_15, [
                        (_ctx.montantTotalSortie)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_16, _toDisplayString((_ctx.montantTotalSortie)) + " Fcfa", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "div row mt-2" }, [
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Monnaie")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Quantité")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Montant")
                        ])
                      ], -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "hr mt-0" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageSortieList, (billetage, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "div container-tight m-0 py-1"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                name: "monnaie",
                                "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                readonly: "",
                                class: "form-control compact-input",
                                placeholder: "Monnaie"
                              }, null, 8, _hoisted_20), [
                                [_vModelText, billetage.libelle]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_Field, {
                                name: `billetageSortieList[${index}].qteBillet`,
                                type: "number",
                                min: "0",
                                modelValue: billetage.qteBillet,
                                "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                onInput: event => _ctx.handleBilletageInput(event, billetage, 'sortie'),
                                onKeypress: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restrictInput($event))),
                                class: "form-control compact-input",
                                placeholder: "Qté"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `billetageSortieList[${index}].qteBillet`,
                                class: "text-danger compact-error"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                readonly: "",
                                placeholder: "Montant",
                                class: "form-control compact-input"
                              }, null, 8, _hoisted_23), [
                                [_vModelText, billetage.montant]
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "div col-md-7" }, [
                        _createElementVNode("h3", { class: "h3 fs-4 text-white" }, "ENTRÉES ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_27, [
                        (_ctx.montantTotalEncaissement)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_28, _toDisplayString((_ctx.montantTotalEncaissement)) + " Fcfa", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "div row mt-2" }, [
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Monnaie")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Quantité")
                        ]),
                        _createElementVNode("div", { class: "div col-md-4" }, [
                          _createElementVNode("label", { class: "label fw-semibold" }, "Montant")
                        ])
                      ], -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "hr mt-0" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageList, (billetage, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "div container-tight m-0 py-1"
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _withDirectives(_createElementVNode("input", {
                                name: "monnaie",
                                "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                readonly: "",
                                class: "form-control compact-input",
                                placeholder: "Monnaie"
                              }, null, 8, _hoisted_32), [
                                [_vModelText, billetage.libelle]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_Field, {
                                name: `billetageList[${index}].qteBillet`,
                                type: "number",
                                min: "0",
                                modelValue: billetage.qteBillet,
                                "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                onInput: event => _ctx.handleBilletageInput(event, billetage, 'encaissement'),
                                onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.restrictInput($event))),
                                class: "form-control compact-input",
                                placeholder: "Qté"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `billetageList[${index}].qteBillet`,
                                class: "text-danger compact-error"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                readonly: "",
                                placeholder: "Montant",
                                class: "form-control compact-input"
                              }, null, 8, _hoisted_35), [
                                [_vModelText, billetage.montant]
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              (_ctx.montantError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.montantError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary top-end",
                  disabled: _ctx.montantError
                }, "Envoyer", 8, _hoisted_38),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger mx-1",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelOperation && _ctx.cancelOperation(...args)))
                }, "Annuler")
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}